import React from "react";
import StarRatings from "react-star-ratings";

export default class StarWidget extends React.Component {
  constructor() {
    super();
    this.state = {
      rating: 0,
    };
  }
  changeRating = (newRating, name) => {
    const { updateRating } = this.props;

    if (updateRating) {
      updateRating(newRating);
    }

    this.setState({
      rating: newRating,
    });
  };

  render() {
    return (
      <StarRatings
        rating={this.state.rating}
        starEmptyColor="rgb(223,224,227)"
        starDimension="30px"
        starRatedColor="green"
        starHoverColor="green"
        changeRating={this.changeRating}
        numberOfStars={5}
        name="rating"
      />
    );
  }
}

// class Bar extends Component {
//   render() {
//     // aggregateRating = 2.35;
//     return (
//       <StarRatings
//         rating={2.403}
//         starDimension="40px"
//         starSpacing="15px"
//       />
//     );
//   }
